import { createFileRoute, redirect } from '@tanstack/react-router'

/** Visits are opened from their job or the schedule: the bare path lands on the service jobs. */
export const Route = createFileRoute('/_app/service/visits/')({
  beforeLoad: () => {
    throw redirect({ to: '/service/jobs', replace: true })
  },
})
